const u = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?q=85&w=${w}&auto=format&fit=crop`;
const p = (id, w = 1600) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const IMG = {
  hero: u("photo-1668957065934-089d0229662f", 2400),
  coastAerial: p(30013786),
  turquoise: p(38675673),
  sandyBeach: u("photo-1685975875980-f19fbd4d36a6"),
  boatBeach: u("photo-1686641954741-7722f5385996"),
  islandHill: u("photo-1660020214290-800d5775a867"),
  birdseyeBeach: u("photo-1735094365748-07b16a185749"),
  coastCliff: p(8332560),
  sunsetCliff: p(7652328),
  beachResort: p(38422897),
  palmGroves: p(38651759),
  poolLounge: u("photo-1668957065532-5770d193d501"),
  poolChairs: u("photo-1651108066220-f61c22fc281f"),
  poolRice: u("photo-1675657144361-98ae33e6b6f9"),
  poolAerial: u("photo-1634671651144-adbeca8623cb"),
  poolPalms: p(19570521),
  villaInterior: p(28256945),
  lounge: p(37526426),
  infinityCliff: p(7969206),
  terracesAerial: u("photo-1559628233-eb1b1a45564b"),
  terracesPalm: u("photo-1555400038-63f5ba517a47"),
  terracesGreen: p(36810327),
  terracesRows: u("photo-1513415756790-2ac1db1297d0"),
};

// Indicative market data compiled from public sources (BPS-Statistics NTB,
// NTB Tourism Office, ITDC Mandalika). Index: 2019 = 100.
export const APPRECIATION = {
  years: ["2019", "2020", "2021", "2022", "2023", "2024", "2025"],
  lombok: [100, 114, 131, 156, 188, 224, 266],
  bali: [100, 107, 114, 124, 135, 146, 158],
};

export const YIELDS = [
  { region: "Kuta – Mandalika", villa: 11, land: 19 },
  { region: "Selong Belanak", villa: 10, land: 21 },
  { region: "Tanjung Aan", villa: 10, land: 20 },
  { region: "Gerupuk", villa: 12, land: 17 },
  { region: "Mawun", villa: 10, land: 18 },
  { region: "Gili Islands", villa: 9, land: 14 },
];

export const ISLAND_STATS = [
  { k: "15–25%", l: "typical annual land appreciation, South Lombok (2019–2025)" },
  { k: "+166%", l: "growth of the prime land index since 2019" },
  { k: "8–12%", l: "gross rental yields on managed villas" },
  { k: "≈3.2M", l: "visitors to Lombok & the Gili Islands in 2019" },
];

export const GEO_FACTS = [
  { k: "3,726 m", l: "Mt. Rinjani, Indonesia's second-highest volcano" },
  { k: "4,724 km²", l: "island surface — Lombok is Bali's quieter twin" },
  { k: "≈3.4M", l: "residents across five regencies" },
  { k: "2011", l: "Lombok International Airport opened, direct flights to Singapore & KL" },
];

export const MILESTONES = [
  { year: "2011", t: "Lombok International Airport opens" },
  { year: "2017", t: "Mandalika designated a National Strategic Zone (SEZ)" },
  { year: "2022", t: "MotoGP debuts at the Mandalika street circuit" },
  { year: "2024", t: "Direct international flights: Singapore, KL, Perth" },
];

export const REGIONS = [
  {
    name: "Kuta & Mandalika",
    img: IMG.coastAerial,
    note: "The engine of the south — the SEZ, the circuit, the new hotels, and the land corridors around them.",
  },
  {
    name: "Selong Belanak",
    img: IMG.sandyBeach,
    note: "A kilometre-wide crescent of sand; hillside headlands now the island's most contested land.",
  },
  {
    name: "Tanjung Aan",
    img: IMG.birdseyeBeach,
    note: "Twin bays and beach clubs, ten minutes east of Kuta. Where villa supply is thinnest.",
  },
  {
    name: "Gerupuk & Ekas",
    img: IMG.coastCliff,
    note: "The surf coast. Small lodges, loyal guests, and yields that out-run the south-east.",
  },
  {
    name: "Mawun & the south bays",
    img: IMG.turquoise,
    note: "A twin-curve bay of turquoise water between Kuta and Selong Belanak — villa plots on the ridges, sand all to themselves.",
  },
  {
    name: "The Gili Islands",
    img: "/img/gili.jpg",
    note: "Three car-free islands, thirty minutes offshore. Boutique bungalows, global demand.",
  },
];

export const TIERS = [
  {
    id: "land-reserve",
    name: "Land Reserve",
    tag: "Founder land banking",
    min: "from $50,000",
    target: "15–20% p.a.",
    horizon: "5–10 years",
    points: [
      "Fractional plots in pre-development corridors",
      "Quarterly independent valuations",
      "Exit & resale assistance at term",
      "Target land appreciation 15–20% per year",
    ],
    featured: false,
  },
  {
    id: "syndicate-estate",
    name: "Syndicate Estate",
    tag: "Fractional villa ownership",
    min: "from $250,000",
    target: "8–12% yield + appreciation",
    horizon: "3–7 years",
    points: [
      "Co-ownership of managed boutique villas",
      "Fully managed — staff, marketing, upkeep",
      "Annual owner-stay allocation",
      "Rental distributions paid quarterly",
    ],
    featured: true,
  },
  {
    id: "sovereign-haven",
    name: "Sovereign Haven",
    tag: "Turnkey estate mandate",
    min: "from $1,000,000",
    target: "10–14% combined IRR target",
    horizon: "Flexible",
    points: [
      "Complete estate acquisition & development",
      "Dedicated asset manager",
      "Structuring, licensing & residency support",
      "Priority access to off-market inventory",
    ],
    featured: false,
  },
];
